


export default {
  title: 'Contact Us',
  subTitle1: 'Head office',
  subTitle2: 'Wuxi Kelke instrument Valve Co., LTD',
  // contactTxt: '24-hour service hotline',
  contactTxt: '24/7 Call line (Chinese)',
  qrcodeLabel: `Follow us：<span style="font-weight:normal">Welcome to Wuxi Kelke intelligent service platform to initiate a conversation</span>`,
  info_list: [
    {
      label: "Email：",
      content: "info@kelkflow.com.cn"
    },
    {
      label: "Phone/Wechat：",
      content: "+86-13951576318(China)"
    },
    {
      label: "Phone/WhatsApp：",
      content: "+1-7788738683(0versea)"
    },
    /* {
      label: "WhatsApp：",
      content: "+1-7788738683"
    }, */
    {
      label: "",
      content: `
        <div style="color: #00335a;margin-top:-10px;">
          (Working hours: Monday to Friday, 8:00 am - 4:30 PM)
        </div>
      `
    },
    {
      label: "Office address：",
      content: "No.6, Daoyu Road, Houzhai, Hongshan Town, Xinwu District, Wuxi City, Jiangsu Province, China"
    },
  ],
  qrcodeList: [
    {
      icon: require("@/assets/images/callMe/haiwai_01.png"),
      selectIcon: '',
      qr_code: '',
      value: '',
      seen: false,
      link: '',
      isShow:false,
    },
    {
      icon: require("@/assets/images/callMe/haiwai_02.png"),
      selectIcon: '',
      qr_code: '',
      value: '',
      seen: false,
      link: '',
      isShow:false,
    },
    {
      icon: require("@/assets/images/callMe/haiwai_03.png"),
      selectIcon: '',
      qr_code: '',
      value: '',
      seen: false,
      link: '',
      isShow:false,
    },
    {
      icon: require("@/assets/images/callMe/haiwai_04.png"),
      selectIcon: '',
      qr_code: '',
      value: '',
      seen: false,
      link: '',
      isShow:false,
    },
  ],
  form: {
    title: 'Online message',
    // sign:'If you need to contact us, please scan the QR code above to log in to the Kelk mini program and leave a message directly or at the following location on the webpage. We will contact you as soon as possible',
    // sign:`You can scan the exclusive entrance on the left to enter the Kelke Intelligent Service platform to initiate a conversation; Or submit the request through the PC or wechat mini program. Our service network will activate the ultra-fast response mechanism and be connected by dedicated engineers within 2 hours to enable your industrial intelligence upgrade with a full-link solution`,
    // tipSign: 'Working hours: Monday to Friday, 8:00 am - 4:30 PM',
    usernameLabel: 'Name',
    businessLabel: 'Corporation',
    telPhoneLabel: 'Tel phone',
    emailLabel: 'Email',
    emailCodeLabel:'Email-Code',
    dutiesLabel:'Duties',
    uploadLabel:'Annex',
    uploadPlaceholder:'Upload attachments',
    leaveContentPlaceholder: 'Please enter content',
    submitBtn: 'Submit'
  },
  group1: [
    {
      title: 'KELK Global Network',
      content: `With Wuxi headquarters as the core, Wuxi Kelke radiates six regions, including East, South and North China, and builds a localized service network covering 30 provinces and cities across the country. 300+ professional engineer team and 50 spare parts warehouse linkage, committed to 8 hours to arrive at any customer site in China, from pre-sales selection consultation, installation and debugging to troubleshooting of the full cycle of service. Relying on the digital remote diagnosis system and standardized service process, to achieve 7×24 hours of rapid response, solve more than 2,000 cases of emergency problems annually, shorten customer downtime with "zero distance" service, and escort industrial flow control safety`,
      button: 'View network',
      path: '/about'
    },
    {
      title: 'Join KELK',
      content: `In the star sea of precision control valves and industrial fluid technology, talent is the engine of Kelke's anchoring innovation and global success. As a benchmark enterprise of technology integration in China and Canada, we know that every low-temperature cryogenic valve that breaks the import monopoly and every set of intelligent flow control system that serves national energy projects come from an elite team that dares to break into no man's land of technology`,
      button: 'Join us',
      path: '/joinIn'
    }
  ],
  varificationCode: {
    title: 'Please verify your email address',
    desc1: `Since this is the first time you have left a message on the website, We have sent a text message with your unique $length digit code to your email address <strong style="color:#333;">$email</strong>`,
    desc1: `
      As this is your first message on the website, we have sent a message with your unique $length-digit code to your mailbox <strong style="color:#333;">$email</strong>, valid for 15 minutes, please note that check.<br />
      (<span style="font-size:1.0625rem;color:#063358">If you do not receive the email, please check whether the email address is correct or check the spam mailbox in the mailbox. If you still do not receive the verification code, please call <strong>+86-18961832100</strong> or send an email to <strong>info@kelkflow.com.cn</strong> for consultation</span>)
    `,
    desc2: `Please enter the code below to confirm your email address`,
    btnTxt1: 'Get the new verification code',
    btnTxt2: 'Getting...',
    closeBtn: 'Close',
    confirmBtn: 'Submit',
    getErrorTip1: 'Obtaining failed. The email address cannot be empty',
    getErrorTip2: 'Failed to obtain, please check and re-obtain!',
    getSuccessTip: 'Verification code has been sent, please go to the email to check',
  },

  messageDetailsTxt: 'Message details',

  messageSuccessModal: {
    title: 'Online message',
    closeBtn: 'Close',
    confirmBtn: 'View message',
    desc1: `If you have questions that you need to consult, our experts can help you. Please leave your questions in "Contact us". If you have a reference number and would like to know the progress, please click <a style="color:#00a4ff;text-decoration:underline;" href="#/message-record">View message</a>, other questions can also contact <strong>051088582008</strong> or email <strong>info@kelkflow.com.cn</strong>`,
    desc2: `
    Thank you for your inquiry! An email confirmation has been sent to your email account with a link to your inquiry details. KELK experts will respond to your questions as soon as possible, you can click on the question link in the email to see the latest status of the consultation. Or if you need to, you can contact our customer Service department for more information about this consultation. Your enquiry ID number is <strong>$m_no</strong>
    `
  }
}


// WEBPACK FOOTER //
// ./src/config/lang/en/contactUs.js